export const LEGAL_CHECK_FORM_URL_WITH_SOURCE = '/legal-check-form/?source=promo';
